var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinCorporateService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11158_6950",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.625H40V40.625H0V0.625Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11158_6950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 31.192L29.583 31.34M12.75 38.625H24.917C25.9779 38.625 26.9953 38.2036 27.7454 37.4534C28.4956 36.7033 28.917 35.6859 28.917 34.625V9.625C28.917 8.56413 28.4956 7.54672 27.7454 6.79657C26.9953 6.04643 25.9779 5.625 24.917 5.625H12.749C11.6881 5.625 10.6707 6.04643 9.92057 6.79657C9.17043 7.54672 8.749 8.56413 8.749 9.625V34.625C8.749 35.6859 9.17043 36.7033 9.92057 37.4534C10.6707 38.2036 11.6881 38.625 12.749 38.625H12.75Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9878 36.398C19.7472 36.398 20.3628 35.7824 20.3628 35.023C20.3628 34.2636 19.7472 33.648 18.9878 33.648C18.2284 33.648 17.6128 34.2636 17.6128 35.023C17.6128 35.7824 18.2284 36.398 18.9878 36.398Z",
    fill: "#76BC21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8672 8.30103H17.6602C17.2802 8.30103 16.9722 8.60883 16.9722 8.98853C16.9722 9.36822 17.2802 9.67603 17.6602 9.67603H20.8672C21.2471 9.67603 21.5552 9.36822 21.5552 8.98853C21.5552 8.60883 21.2471 8.30103 20.8672 8.30103Z",
    fill: "#76BC21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinCorporateService);
export default __webpack_public_path__ + "static/media/minCorporateService.6d53e3bd4061f4d7a69a65e241297406.svg";
export { ForwardRef as ReactComponent };